import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=a9a3e4f8&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=a9a3e4f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a3e4f8",
  null
  
)

export default component.exports